import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-group-payment-page',
  templateUrl: './group-payment-page.component.html',
})
export class GroupPaymentPageComponent {
  @Input() body: unknown;
}
